
import clip from '@/utils/clipboard'; // use clipboard directly
import { fetchTaskDetail } from '@/api/qa/task';
export default {
  props: {
    detail: Object
  },
  watch: {
    'detail.visible': function detailVisible(val) {
      var _this = this;

      if (val) {
        if (this.detail.id) {
          this.loading = true;
          this.showPublishDetail = false;
          fetchTaskDetail({
            id: this.detail.id
          }).then(function (res) {
            _this.loading = false;
            _this.data = res.data.data;
            _this.title = '查看详情：' + (_this.data.info.app_info || [])[0].name;
          }).catch(function () {
            _this.loading = false;
            // eslint-disable-next-line vue/no-mutating-props
            _this.detail.visible = false;
          });
        }
      }
    }
  },
  computed: {
    extra_config: function extra_config() {
      var config = {};
      if (this.data.info && this.data.info.extra_config) {
        try {
          config = JSON.parse(this.data.info.extra_config);
        } catch (error) {
          console.warn('info.extra_config的内容无法做json解析');
        }
      }
      return config;
    },
    relatedTable: function relatedTable() {
      var relatedTable = [];
      if (this.data.info) {
        try {
          relatedTable = [{
            demander: this.data.info.demander,
            account_manager: this.data.info.account_manager,
            designer: this.data.info.designer,
            developer: this.data.info.developer,
            tester: this.data.info.tester
          }];
        } catch (error) {
          console.warn('data.info的内容无法得到');
        }
      }
      return relatedTable;
    }
  },
  data: function data() {
    return {
      title: '',
      loading: false,
      data: {},
      showPublishDetail: false
    };
  },

  methods: {
    handleCopy: function handleCopy(text, event) {
      clip(text, event);
    }
  }
};